module.exports = __webpack_public_path__ + "static/media/icn_dropdown_black.4921cc38.svg";